import UnderMaintenanceOrChildren from "../components/UnderMaintenanceOrChildren/UnderMaintenanceOrChildren";
import SignUpContainer from "../containers/SignUpContainer";

const SignUpPage = () => {
  return (
    <UnderMaintenanceOrChildren>
      <SignUpContainer />
    </UnderMaintenanceOrChildren>
  );
};

export default SignUpPage;
